export function MeshBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-surface-base">
      <div className="absolute -top-48 -left-48 w-[500px] h-[500px] rounded-full bg-primary/[0.18] blur-3xl animate-blob" />
      <div className="absolute -bottom-48 -right-48 w-[500px] h-[500px] rounded-full bg-accent/[0.15] blur-3xl animate-blob-delay" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-indigo-600/[0.08] blur-3xl animate-blob-slow" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(14,165,233,0.05)_0%,transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(16,185,129,0.05)_0%,transparent_50%)]" />
    </div>
  )
}
